import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold tracking-[0.05em] transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:     "border-transparent bg-primary/20 text-primary",
        secondary:   "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive/20 text-destructive",
        success:     "border-transparent bg-success/20 text-success",
        warning:     "border-transparent bg-destructive/20 text-destructive",
        outline:     "text-foreground",
        // norm-specific
        plan:  "border-transparent bg-primary/20 text-primary",
        do:    "border-transparent bg-primary/15 text-primary/90",
        check: "border-transparent bg-destructive/20 text-destructive",
        act:   "border-transparent bg-success/20 text-success",
        // norm classification
        ncMaior: "border-transparent bg-destructive text-white",
        ncMenor: "border-transparent bg-destructive/60 text-white",
        obs:     "border-transparent bg-muted-foreground/20 text-muted-foreground",
        odm:     "border-transparent bg-primary text-white",
        c:       "border-transparent bg-success text-white",
        // norms (only for clauses requirements)
        iso9001:  "border-transparent bg-destructive/20 text-destructive border-destructive/40 border",
        iso14001: "border-transparent bg-success/20 text-success border-success/40 border",
        iso45001: "border-transparent bg-destructive/15 text-destructive/80 border-destructive/30 border",
      },
    },
    defaultVariants: { variant: "default" },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
